export const updateItinerary = (itinerary, nights, startDateStr) => {
  const suffix = d =>
    d >= 11 && d <= 13 ? "th" : { 1: "st", 2: "nd", 3: "rd" }[d % 10] || "th"

  const formatLabel = (dayStart, duration) =>
    duration === 1
      ? `Day ${dayStart}`
      : `Days ${dayStart}–${dayStart + duration - 1}`

  const formatDate = date => {
    const d = new Date(date)
    return `${d.toLocaleString("en-US", {
      month: "long",
    })} ${d.getDate()}${suffix(d.getDate())}, ${d.getFullYear()}`
  }

  const result = []
  let currentDay = 1
  let currentDate = new Date(startDateStr)

  itinerary.forEach((entry, i) => {
    const nightKey = `day_${i + 1}`
    const nightsHere = nights[nightKey] || 1

    const label = formatLabel(currentDay, nightsHere)

    const dateLabel =
      nightsHere === 1
        ? formatDate(currentDate)
        : `${formatDate(currentDate)} to ${formatDate(
            new Date(currentDate.getTime() + (nightsHere - 1) * 86400000),
          )}`

    const overnightAttr = entry.attributes.find(
      a => a.key === "Overnight Location",
    )
    const overnight =
      overnightAttr?.value && overnightAttr.value !== "None"
        ? ` - Overnight at ${overnightAttr.value}`
        : ""

    result.push(`${label} - ${dateLabel} - ${entry.title}${overnight}`)

    currentDay += nightsHere
    currentDate = new Date(
      currentDate.getTime() + nightsHere * 24 * 60 * 60 * 1000,
    )
  })

  return result
}
